import Swiper, { Autoplay } from 'swiper'
Swiper.use([Autoplay])

const sliders = []

let slidersHtml = document.querySelectorAll('.swiper-logos')

if (slidersHtml.length) {
  slidersHtml.forEach(sliderHtml => {

    sliders.push(new Swiper(sliderHtml, {
      slidesPerView: 6,
      slidesPerGroup: 1,
      autoplay: {
        delay: 2000
      },
      centerInsufficientSlides: true,
      watchOverflow: true,
      breakpoints: {
        320: {
          slidesPerView: 2,
        },
        480: {
          slidesPerView: 3,
        },
        640: {
          slidesPerView: 4,
        },
        760: {
          slidesPerView: 5,
        },
        960: {
          slidesPerView: 6,
        }
      }
    }))
  })
}



// WEBPACK FOOTER //
// ./scripts/modules/logos.js